import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiFaqSectionDTO,
  FaqSectionDTO,
} from "@lib/strapi/dtos/components/sections/faqSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class FaqSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiFaqSectionDTO,
  ): Promise<FaqSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new FaqSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.source = strapiData.source;
    dto.curatedQuestionIds = (strapiData.curatedQuestions ?? [])
      .map((q) => q?.documentId)
      .filter(Boolean);
    dto.emitStructuredData = strapiData.emitStructuredData;
    return dto;
  }
}
